<template>
    <div class="common-login sustainable-component">

        <!-- Snackbar – success -->
        <v-snackbar v-model="showSnackBar" color="success" :timeout="2000">
            {{ snackbarMessage }}
        </v-snackbar>

        <!-- Snackbar – error -->
        <v-snackbar v-model="showErrorSnackBar" color="error" :timeout="2000">
            {{ errorMessage }}
        </v-snackbar>

        <!-- LOGIN DIALOG -->
        <v-dialog v-model="dialog" persistent max-width="420px">
            <v-card>

                <v-card-title class="bg-primary text-white">
                    Logga in igen
                </v-card-title>

                <v-card-text class="pt-4 pb-0">
                    <common-spinner :loading="loading > 0" />

                    <p class="mb-4">
                        Din session har gått ut och du har blivit utloggad.<br />
                        Logga in igen för att fortsätta arbeta med ditt valda bolag.
                    </p>

                    <v-alert v-if="error"
                             type="error"
                             title="Felaktig inloggning!"
                             :text="error"
                             class="mb-3" />

                    <v-text-field v-model="username"
                                  class="login-autofill-field"
                                  variant="outlined"
                                  bg-color="white"
                                  label="Användarnamn"
                                  autocomplete="username"
                                  density="comfortable" />

                    <common-password v-model="password"
                                     class="login-autofill-field"
                                     variant="outlined"
                                     bg-color="white"
                                     label="Lösenord"
                                     density="comfortable" />
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn 
                           @click="cancel"
                           >
                        Avbryt
                    </v-btn>
                    <v-btn color="primary"
                           @click="login"
                           :disabled="disabled">
                        Logga in
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import CommonService from "../Services/CommonService";
    import CommonSpinner from "./common-spinner.vue";
    import CommonPassword from "./common-password.vue";

    export default {
        name: "CommonLogin",

        components: {
            CommonSpinner,
            CommonPassword,
        },

        props: {
            company: {
                type: String,
                default: "-1",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                dialog: false,
                username: "",
                password: "",
                error: null,

                loading: 0,

                // Snackbars
                showSnackBar: false,
                snackbarMessage: null,
                showErrorSnackBar: false,
                errorMessage: null,
            };
        },

        methods: {
            openLogin() {
                this.dialog = true;
            },
            async cancel() {
                this.dialog = false;
            },
            async login() {
                this.loading++;

                try {
                    const result = await CommonService.authenticateWithCompany(
                        this.username,
                        this.password,
                        this.company
                    );

                    if (!result.ErrorMessage) {
                        this.snackbarMessage = "Du är inloggad igen";
                        this.showSnackBar = true;
                        this.dialog = false;
                    } else {
                        this.error = result.ErrorMessage;
                    }
                } catch (e) {
                    this.errorMessage = "Ett oväntat fel inträffade";
                    this.showErrorSnackBar = true;
                }

                this.loading--;
            },
        },

        mounted() {
            // Öppna modalen när eventet triggas
            window.emitter.on("display_login", this.openLogin);
        },

        unmounted() {
        },
    };
</script>

<style scoped>
    .common-login {
        /* tom - kan användas vid behov */
    }
</style>
